import * as zExt from "@redotech/rpc/ext";
import { privacy } from "@redotech/schema-privacy";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export enum GoldenDomeNotificationType {
  SLACK = "SLACK",
}

// Maps to the analyst roles on `HubspotTeamInfo.productAnalysts`. When a
// subscription fires, only analysts whose role appears here are tagged in
// the Slack alert.
export enum GoldenDomeProductArea {
  RETURNS = "returns",
  OMS = "oms",
  MARKETING = "marketing",
  CONVERSION = "conversion",
  SHOPPER_AI = "shopperAI",
}

const notificationSentSchema_ = z.object({
  timestamp: z.date().meta({ privacy: privacy.nonPii }),
  teamId: z.string().meta({ privacy: privacy.nonPii }),
  appId: z.string().meta({ privacy: privacy.nonPii }),
});

const goldenDomeNotificationSchema_ = z.object({
  _id: zExt.objectId().meta({ privacy: privacy.nonPii }),
  userEmail: z.string().meta({ privacy: privacy.email }),
  appIds: z
    .array(z.string().meta({ privacy: privacy.nonPii }))
    .meta({ privacy: privacy.nonPii }),
  notificationsSent: z
    .array(notificationSentSchema_)
    .meta({ privacy: privacy.structured }),
  title: z.string().meta({ privacy: privacy.free_text }),
  customMessage: z.string().optional().meta({ privacy: privacy.free_text }),
  notificationType: createEnum(GoldenDomeNotificationType, {
    enumName: "golden_dome_notification_type",
  }).meta({ privacy: privacy.nonPii }),
  includeAppInstallationRemoved: z
    .boolean()
    .optional()
    .meta({ privacy: privacy.nonPii }),
  productAreas: z
    .array(
      createEnum(GoldenDomeProductArea, {
        enumName: "golden_dome_product_area",
      }),
    )
    .optional()
    .meta({ privacy: privacy.nonPii }),
  createdAt: z.date().meta({ privacy: privacy.nonPii }),
  updatedAt: z.date().meta({ privacy: privacy.nonPii }),
});

export const GoldenDomeNotificationSchema: z.ZodType<GoldenDomeNotification> =
  goldenDomeNotificationSchema_;
export interface GoldenDomeNotification extends z.infer<
  typeof goldenDomeNotificationSchema_
> {}
